import React, { useState } from "react";

const ChatWidget = ({ navigate }) => {
  const [open, setOpen] = useState(false);

  return (
    <div className="fixed bottom-6 right-6 z-[9999] flex flex-col items-end gap-3">
      {/* Chat box */}
      {open && (
        <div className="w-72 bg-white rounded-2xl shadow-[0_20px_60px_rgba(0,0,0,.22)] border border-slate-200 overflow-hidden">
          {/* Header */}
          <div className="bg-gradient-to-r from-blue-600 to-blue-500 px-4 py-3.5 flex items-center gap-3">
            <div className="w-9 h-9 rounded-full bg-white/20 flex items-center justify-center shrink-0">
              <svg viewBox="0 0 24 24" fill="white" className="w-4 h-4">
                <path d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"/>
              </svg>
            </div>
            <div>
              <h4 className="font-head font-semibold text-white text-sm">Eminent AI Assistant</h4>
              <p className="text-white/65 text-xs">Typically replies in minutes</p>
            </div>
            <button onClick={() => setOpen(false)} className="ml-auto text-white/60 hover:text-white bg-transparent border-none cursor-pointer text-lg leading-none">×</button>
          </div>

          {/* Body */}
          <div className="p-4 bg-slate-50">
            <div className="bg-white rounded-xl rounded-tl-sm p-3 text-slate-700 text-sm leading-relaxed shadow-sm border border-slate-100">
              👋 Hi there! Need help finding the right AI solution for your business? I'm here to help.
            </div>
          </div>

          {/* Actions */}
          <div className="px-4 pb-4 bg-slate-50 border-t border-slate-100 pt-3 space-y-2">
            <button
              onClick={() => { navigate("contact"); setOpen(false); }}
              className="w-full bg-orange-500 text-white font-head font-semibold text-sm py-2.5 rounded-xl cursor-pointer border-none hover:bg-orange-400 transition-colors"
            >
              Talk to Us
            </button>
            <button
              onClick={() => { navigate("demo"); setOpen(false); }}
              className="w-full bg-slate-100 text-slate-700 font-head font-semibold text-sm py-2.5 rounded-xl cursor-pointer border-none hover:bg-slate-200 transition-colors"
            >
              Explore Demo Now
            </button>
          </div>
        </div>
      )}

      {/* Bubble */}
      <button
        onClick={() => setOpen(v => !v)}
        className="w-14 h-14 rounded-full bg-gradient-to-br from-blue-600 to-blue-500 flex items-center justify-center cursor-pointer border-none shadow-[0_8px_24px_rgba(30,86,217,.4)] hover:scale-110 transition-transform duration-200"
      >
        {open ? (
          <svg viewBox="0 0 24 24" fill="white" className="w-6 h-6">
            <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L12 10.586l6.293-6.293a1 1 0 111.414 1.414L13.414 12l6.293 6.293a1 1 0 01-1.414 1.414L12 13.414l-6.293 6.293a1 1 0 01-1.414-1.414L10.586 12 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd"/>
          </svg>
        ) : (
          <svg viewBox="0 0 24 24" fill="white" className="w-6 h-6">
            <path d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"/>
          </svg>
        )}
      </button>
    </div>
  );
};

export default ChatWidget;
